import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { DashboardConsumer } from '../../layouts/PanelLayoutContext';
import {
    Menu as MenuIcon,
    User,
    LogOut,
    Command
} from 'lucide-react';
import Logo from '../ui/LogoComponent';
import { connect } from 'react-redux';
import { Logout as LogoutD } from '../../contexts/Reducers/SessionSlice';
import { LSRoutes } from '../../LYSEPHelper';

import GlobalSearch from '../ui/GlobalSearch';
import { Search } from 'lucide-react';

// Connect to Redux
const mapStateToProps = (state) => ({
    // Add any needed state props here
    canAccessModule: (moduleName) => {
        // This is a simple mock or should be connected to actual permission logic
        // For now, let's assume it's available in the context or via a helper
        return true;
    }
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(LogoutD())
});

class Navbar extends Component {
    constructor(props) {
        super(props)
        this.Logout = this.Logout.bind(this);
        this.state = {
            profileMenuAnchor: null,
            isSearchOpen: false
        };
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleGlobalKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleGlobalKeyDown);
    }

    handleGlobalKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
            e.preventDefault();
            this.setState({ isSearchOpen: true });
        }
    };

    toggleSearch = () => {
        this.setState(prev => ({ isSearchOpen: !prev.isSearchOpen }));
    };

    handleProfileMenuOpen = (event) => {
        this.setState({ profileMenuAnchor: event.currentTarget });
    };

    handleProfileMenuClose = () => {
        this.setState({ profileMenuAnchor: null });
    };

    Logout() {
        if (this.props.logout) {
            this.props.logout();
            this.handleProfileMenuClose();
        }
    }
    render() {
        return (
            <nav className="sticky top-0 z-[102] w-full bg-[#0f1115]/95 backdrop-blur-xl border-b border-white/[0.06] shadow-sm navbar">
                <div className="flex items-center justify-between px-4 h-16">
                    {/* Left Side: Menu Toggle + Logo */}
                    <div className="flex items-center gap-4">
                        <DashboardConsumer>
                            {dbContext => (
                                <button
                                    onClick={() => {
                                        dbContext.dispatch(dbContext, { name: "SET_SIDEBAR", data: dbContext.sidebarState === 1 ? 0 : 1 })
                                    }}
                                    className="p-2 rounded-md hover:bg-white/5 text-gray-300 transition-colors"
                                >
                                    <MenuIcon className="w-6 h-6" />
                                </button>
                            )}
                        </DashboardConsumer>

                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 flex items-center justify-center">
                                <Logo color="#fd7000" className="lysep-logo w-full h-full" small={1} loading={1} />
                            </div>
                            <span className="text-xl font-bold logo-typo text-white hidden sm:block">
                                LYSEP
                            </span>
                        </div>
                    </div>

                    {/* Center Search Bar Trigger */}
                    <div className="flex-1 max-w-md mx-8 hidden md:block">
                        <button
                            onClick={this.toggleSearch}
                            className="w-full flex items-center justify-between px-4 py-2 bg-white/[0.03] border border-white/[0.08] hover:border-white/[0.15] hover:bg-white/[0.06] rounded-xl text-gray-500 transition-all group"
                        >
                            <div className="flex items-center gap-3">
                                <Search className="w-4 h-4 group-hover:text-gray-300 transition-colors" />
                                <span className="text-sm">Hızlı arama...</span>
                            </div>
                            <div className="flex items-center gap-1.5 px-1.5 py-0.5 bg-white/[0.05] border border-white/[0.1] rounded-lg">
                                <Command className="w-3 h-3" />
                                <span className="text-[10px] font-bold">K</span>
                            </div>
                        </button>
                    </div>

                    {/* Right Side: Profile Dropdown */}
                    <div className="flex items-center gap-2">
                        {/* Mobile Search Icon */}
                        <button
                            onClick={this.toggleSearch}
                            className="p-2 md:hidden rounded-full hover:bg-white/5 text-gray-400 transition-colors"
                        >
                            <Search className="w-6 h-6" />
                        </button>

                        <div className="relative">
                            <button
                                onClick={this.handleProfileMenuOpen}
                                className="p-2 rounded-full hover:bg-white/5 text-gray-300 transition-colors"
                            >
                                <User className="w-6 h-6" />
                            </button>

                            {/* Dropdown Menu */}
                            {this.state.profileMenuAnchor && (
                                <>
                                    <div
                                        className="fixed inset-0 z-40"
                                        onClick={this.handleProfileMenuClose}
                                    ></div>
                                    <div className="absolute right-0 mt-2 w-48 bg-[#252525] border border-white/10 rounded-md shadow-lg py-1 z-50">
                                        <Link
                                            to={LSRoutes.Dashboard('profile')}
                                            className="flex items-center px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white"
                                            onClick={this.handleProfileMenuClose}
                                        >
                                            <User className="w-4 h-4 mr-3" />
                                            Profil
                                        </Link>
                                        <div className="border-t border-white/10 my-1"></div>
                                        <button
                                            onClick={this.Logout}
                                            className="flex w-full items-center px-4 py-2 text-sm text-red-500 hover:bg-red-500/10 text-left"
                                        >
                                            <LogOut className="w-4 h-4 mr-3" />
                                            Çıkış Yap
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Global Search Modal */}
                <DashboardConsumer>
                    {dbContext => (
                        <GlobalSearch
                            isOpen={this.state.isSearchOpen}
                            onClose={() => this.setState({ isSearchOpen: false })}
                            canAccessModule={dbContext.canAccessModule || (() => true)}
                        />
                    )}
                </DashboardConsumer>
            </nav>
        )
    }
}

// Export connected component with router
let ConnectedNavbar = connect(mapStateToProps, mapDispatchToProps)(Navbar);

export default ConnectedNavbar;
